export default "__VITE_ASSET__Bjs5n$w9__"